import LabServiceModel from "@/models/LabServiceModel";
import UserModel from "./UserModel";
import ResultExportModel from "./ResultExportModel";

export default class ResultImportModel extends LabServiceModel {

  modelName() {
    return 'result-import';
  }

  icon() {
    return 'upload';
  }

  defaults() {
    return {
      id: null,
      result_export_id: null,
      user_id: null,
      status: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    }
  }

  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      result_export_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      status: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  validation() {
    return {}
  }

  getResultExport() {
    return this.getRelatedModel(ResultExportModel, 'result_export');
  }

  getUser() {
    return this.getRelatedModel(UserModel, 'user');
  }

}
